import React, { useMemo } from "react";
import DOMPurify from "dompurify";

// Iter40 ter (Security): strict allow-list for the admin-editable referral terms text.
// Mirrors the documented supported tags (h3, p, ul, li, strong, em, br, a href).
// All other tags/attrs are stripped, eliminating the XSS surface via dangerouslySetInnerHTML.
const ALLOWED_TAGS = ["h1", "h2", "h3", "h4", "p", "ul", "ol", "li", "strong", "em", "u", "br", "a", "span", "div"];
const ALLOWED_ATTR = ["href", "target", "rel", "class"];

export default function SafeHtml({ html, className = "", testId }) {
  const clean = useMemo(() => {
    if (!html) return "";
    return DOMPurify.sanitize(String(html), {
      ALLOWED_TAGS,
      ALLOWED_ATTR,
      // Force all anchors to open safely
      ADD_ATTR: ["target"],
    });
  }, [html]);
  return (
    <div
      className={className}
      data-testid={testId}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: clean }}
    />
  );
}
